<template>
  <div v-if="!isLoading">
    <b-container>
      <div class="mt-4 mb-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Commercialisation.lots') }}</h1>
          <h2 class="secondary-text-color bold-text level-three-title">{{ totalCount }}
            {{ totalCount > 1 ? $t('operations') : $t('operation') }}</h2>
        </div>
      </div>


      <!-- Empty State -->
      <template v-if="totalCount === 0">
        <div class="empty-state-container">
          <div class="text-center mb-4">
            <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="empty-state-img">
          </div>
          <div class=" text-center no-result-text">
            <div class="no-result-title mb-2">{{ $t('operation.emptyTitle') }}</div>
            <div class="my-2 main-color-text">{{ $t('operation.emptyText') }}</div>
            <b-button class="my-2" variant="primary" @click="clickOnCreateBtn">
              {{ $t('operation.emptyButton') }}
            </b-button>
          </div>
        </div>
      </template>

      <!-- Opérations -->
      <template v-else>
        <template v-for="operationByStatus in items">

          <div class="mb-2">
            <div v-if="operationByStatus.operations.length !== 0" class="section-title">
              {{ $t(operationByStatus.status.text) }}
            </div>
          </div>

          <div class="mosaic-container row mb-4">
            <template v-for="operation in operationByStatus.operations">
              <div class="col-sm-1 col-md-4 col-lg-4 my-2">
                <b-card class="cursor-pointer" v-on:click="clickOnShowBtn(operation)">
                  <div v-if="operation.picture" class="mb-3  picture-container">
                    <img :src="operation.picture ? getFileUrl(operation.picture.fileUrl) :''" alt=""
                         class="result-img"/>
                  </div>
                  <div v-else class="mb-3 picture-container no-result-container">
                    <img :src="require(`@/assets/images/APRILYOS/emptyState.png`)" alt="No picture" class="no-result-img">
                  </div>

                  <div class="row justify-content-between ml-2 mr-2 px-0">
                    <div style="max-width: 80%;min-width: 150px">
                      <b-link class="main-color-text bold-text level-two-title" v-on:click="clickOnShowBtn(operation)">
                        {{ operation.tostring }}
                      </b-link>
                      <div class="main-color-text"> {{ operation.city }}</div>
                    </div>
                    <div v-if="operation.nbTasks !== 0">
                      <div class="pastille-fail">
                        {{ operation.nbTasks }}
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-sm-between ml-2 mr-2 px-0">
                    <div class="tertiary-color small-text bold-text my-1">
                      {{ $t('lastModifDate') + ': ' + formatDate(operation.lastModifDate) }}
                    </div>
                    <div v-if="operation.bilanType !== 0">
                      <div :class="{'bilan-exe':operation.bilanType==='EXE','bilan-avp':operation.bilanType==='AVP'}"
                           class="pastille-fail">
                        {{ operation.bilanType }}
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </template>
          </div>
        </template>
      </template>
    </b-container>
  </div>
</template>

<script>

import i18n from "../../i18n"
import api from "../../services/api";

export default {

  name: 'CommercialisationLotsIndex',

  components: {},

  data() {
    return {
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      isLoading: false,
      totalCount: 0,
      allowCreate: true,
      items: []
    }
  },

  mounted() {
    this.fetchItems()
  },

  methods: {

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString()
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    fetchItems() {
      this.isLoading = true
      api
        .get('/operation/getAllAuthorizedOperationsByStatus')
        .then(response => {
          this.items = response.data
          this.items.forEach(operationsByStatus => {
            this.totalCount += operationsByStatus.operations.length
          })
          this.isLoading = false
        })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'OperationCreate',
        params: {
          fromSimulation: false
        }
      })
    },

    clickOnShowBtn(item) {
      this.$router.push({
        name: 'CommercialisationLotsShow',
        params: {
          operationId: item.id
        }
      })
    },

  }
}
</script>

<style scoped>

.tertiary-color {
  color: var(--tertiary-text-color);
}

.card-body {
  padding: 0 0 0.5rem;
}

.card {
  border-radius: 0;
  padding: 0;
}


.empty-state-container {
  height: 70%;
  margin-top: 15%;
  margin-bottom: 15%;
}

.empty-state-img {
  max-width: 220px;
}

.no-result-img {
  max-width: 135px;
  max-height: 83px;
}

.picture-container {
  width: 100%;
  height: 125px;
  overflow: hidden;
}

.picture-container .result-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}





</style>



// WEBPACK FOOTER //
// src/views/commercialisation/CommercialisationLotsIndex.vue